import { toId } from 'services/string'

/**
 * To add new departments, please follow the following steps:
 * 1. Add the department name in the array below (this makes the department in departments page)
 * 2. Add the department data in department detail index (this makes the hero section of department detail page)
 */

export const departmentNames = [
  'Customer Experience',
  'Data',
  'Finance',
  'Operations',
  'People Operations',
  'Product',
  'Technology',
]

// departmentList is used to crosscheck with department values received from bambooHr
export const departmentList = departmentNames.map(depName => ({
  id: toId(depName),
  name: depName,
})
)
